import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';

import { environment } from '@libs/src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class WebflowInstanceService {
  private readonly webflowUrl = '/__webflow';

  constructor(private http: HttpClient) {}

  getWebflowPage(params: { url: string }) {
    return environment.production
      ? this.http.get(this.webflowUrl, { params })
      : of(true);
  }
}
